import AdminEventRankingsApp from "./AdminEventRankingsApp.vue";
import { vueAppWithPinia } from "../Common/vueApp";

export default vueAppWithPinia(AdminEventRankingsApp);
